import { createAction, props } from '@ngrx/store';

// Groups Actions
export const loadGroups = createAction(
  '[ReviewEntries] Load Groups',
  props<{ supervisorNumber: number; forceRefresh?: boolean }>()
);

export const loadGroupsSuccess = createAction(
  '[ReviewEntries] Load Groups Success',
  props<{ groups: any[]; supervisorNumber: number }>()
);

export const loadGroupsFailure = createAction(
  '[ReviewEntries] Load Groups Failure',
  props<{ error: any }>()
);

// Departments Actions
export const loadDepartments = createAction(
  '[ReviewEntries] Load Departments',
  props<{
    supervisorNumber: number;
    directReportsOnly: boolean;
    forceRefresh?: boolean;
  }>()
);

export const loadDepartmentsSuccess = createAction(
  '[ReviewEntries] Load Departments Success',
  props<{ departments: any[] }>()
);

export const loadDepartmentsFailure = createAction(
  '[ReviewEntries] Load Departments Failure',
  props<{ error: any }>()
);

// Pending Records Actions
export const loadPendingRecords = createAction(
  '[ReviewEntries] Load Pending Records',
  props<{
    supervisorNumber: number;
    selectedDate: string;
    employeeNumber: number | null;
    page: number;
    itemsPerPage: number;
    sortColumn: string;
    sortOrder: string;
    pageSearchColumn: string;
    pageSearchValue: string;
    directReportsOnly?: boolean;
    noOfDays?: string;
    supervisorReportsOnly?: boolean;
  }>()
);

export const loadPendingRecordsSuccess = createAction(
  '[ReviewEntries] Load Pending Records Success',
  props<{
    pendingRecords: any[];
    totalHours: number;
    totalEquipmentHours: number;
  }>()
);

export const loadPendingRecordsFailure = createAction(
  '[ReviewEntries] Load Pending Records Failure',
  props<{ error: any }>()
);

// Calendar Counts Actions
export const loadCalendarCounts = createAction(
  '[ReviewEntries] Load Calendar Counts',
  props<{
    supervisorNumber: number;
    showAll: boolean;
    groupID: number;
    department?: string;
    currentMonthDate: string;
    forceRefresh?: boolean;
  }>()
);

export const loadCalendarCountsSuccess = createAction(
  '[ReviewEntries] Load Calendar Counts Success',
  props<{ counts: any[] }>()
);

export const loadCalendarCountsFailure = createAction(
  '[ReviewEntries] Load Calendar Counts Failure',
  props<{ error: any }>()
);

// Calendar Info Actions
export const loadCalendarInfo = createAction(
  '[ReviewEntries] Load Calendar Info',
  props<{ employeeNumber: number; calendarDate: any; forceRefresh?: boolean }>()
);

export const loadCalendarInfoSuccess = createAction(
  '[ReviewEntries] Load Calendar Info Success',
  props<{
    calendarInfo: any;
    employeeNumber: number;
    calendarDate: string;
  }>()
);

export const loadCalendarInfoFailure = createAction(
  '[ReviewEntries] Load Calendar Info Failure',
  props<{ error: any }>()
);

export const clearCalendarInfo = createAction(
  '[ReviewEntries] Clear Calendar Info'
);

// Supervisor Head EMp Details Actions
export const loadSupervisorHeadEmpDetails = createAction(
  '[ReviewEntries] Load Supervisor Head Details',
  props<{
    supervisorNumber: number;
    selectedDate: string;
    employeeNumber: number | null;
    pageSearchColumn: string;
    pageSearchValue: string;
    directReportsOnly?: boolean;
    noOfDays?: string;
    supervisorReportsOnly?: boolean;
  }>()
);

export const loadSupervisorHeadEmpDetailsSuccess = createAction(
  '[ReviewEntries] Load Supervisor Head Details Success',
  props<{ supervisorHeadEmpDetails: any[] }>()
);

export const loadSupervisorHeadEmpDetailsFailure = createAction(
  '[ReviewEntries] Load Supervisor Head Details Failure',
  props<{ error: any }>()
);

// Page Supervisor Head Details Actions
export const loadPageSupervisorHeadDetails = createAction(
  '[ReviewEntries] Load Page Supervisor Head Details',
  props<{
    supervisorNumber: number;
    selectedDate: string;
    employeeNumber: number | null;
    pageSearchColumn: string;
    pageSearchValue: string;
    directReportsOnly: boolean;
    noOfDays: number | any;
    viewAll: boolean;
    supervisorReportsOnly: boolean;
  }>()
);

export const loadPageSupervisorHeadDetailsSuccess = createAction(
  '[ReviewEntries] Load Page Supervisor Head Details Success',
  props<{ headDetails: any[] }>()
);

export const loadPageSupervisorHeadDetailsFailure = createAction(
  '[ReviewEntries] Load Page Supervisor Head Details Failure',
  props<{ error: any }>()
);
